/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc notify
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: any;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/payment/best-pay/notify`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
